module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-christian.0b9bc21d.jpeg";